export function getLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve(position);  // Successfully retrieved the position
      },
      (error) => {
        reject(error);  // Error occurred during retrieval
      }
    );
  });
}

export function getLocationSupport() {
  return !!navigator.geolocation;
}
